import { createContext, useContext } from 'react';

import { UserContextInterface } from '@/modules/common/types/user-context.interface';

export const UserContext = createContext<UserContextInterface>({
  hasCompleteProfile: false,
  user: undefined,
  company: undefined,
  loadingUserData: true,
  hasCompanyOnboarded: false,
  isAdmin: false,
  isViewer: false,
  refetch: () => undefined,
  isDeactivated: false,
  isMaterialityScope: false,
  setIsRegistering: () => undefined,
  isRegistering: false,
});
export const useUser = () => useContext(UserContext);
